import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import styled from "styled-components";

const ExpertCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExpertImage = styled.div`
  aspect-ratio: 300/342;
  width: 100%;
  margin-bottom: var(--spacing-1);
`;

const ExpertCardContent = styled.div`
  width: 100%;

  p {
    margin-bottom: 0;
    text-wrap: balance;

    &.expert-title-subhead {
      color: var(--indigo-blue-60);
    }

    &.expert-title {
      margin-top: var(--spacing-0_5);
    }
  }
`;

type PropTypes = {
  expert: {
    name: string;
    title: string;
    image: { title: string; gatsbyImageData: IGatsbyImageData };
  };
};

const ExpertCard = ({ expert }: PropTypes) => {
  const [expertName, ...degrees] = expert.name.split(",");
  return (
    <ExpertCardWrapper>
      <ExpertImage>
        <GatsbyImage
          image={expert.image?.gatsbyImageData}
          alt={expert.image.title}
          draggable="false"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            userSelect: "none",
          }}
          imgStyle={{
            userSelect: "none",
          }}
        />
      </ExpertImage>
      <ExpertCardContent>
        <p className="typography-label1">{expertName}</p>
        {degrees.length > 0 && (
          <p className="typography-body2 font-circular expert-title-subhead">
            {degrees.join(",").trim()}
          </p>
        )}
        {expert.title && (
          <p className="typography-body2 font-dutch expert-title">
            {expert.title}
          </p>
        )}
      </ExpertCardContent>
    </ExpertCardWrapper>
  );
};

export default ExpertCard;
